// extracted by mini-css-extract-plugin
export var body = "_l6-8";
export var button = "_l6-0";
export var closeButton = "_l6-5";
export var content = "_l6-3";
export var empty = "_l6-f";
export var grid = "_l6-c";
export var header = "_l6-4";
export var icon = "_l6-1";
export var option = "_l6-d";
export var optionSelected = "_l6-e";
export var overlay = "_l6-2";
export var searchIcon = "_l6-a";
export var searchInput = "_l6-b";
export var searchWrapper = "_l6-9";
export var title = "_l6-6";
export var visuallyHidden = "_l6-7";